import { EVENTS } from './events';
import { trackEvent } from './gtag';
import { getSessionState } from './sessionTracker';

const HANDLED_ATTR = 'data-analytics-handled';
const ANALYTICS_ID_ATTR = 'data-analytics-id';
const MAX_LABEL_LENGTH = 100;

let initialized = false;

function getVisibleText(element) {
  const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
  return text.slice(0, MAX_LABEL_LENGTH);
}

function getLinkType(href) {
  if (!href) return 'unknown';
  if (href.startsWith('mailto:')) return 'mailto';
  if (href.startsWith('#')) return 'internal_hash';
  if (href.startsWith('/') || href.startsWith(window.location.origin)) {
    if (href.includes('.pdf')) return 'download';
    return 'internal_path';
  }
  if (href.startsWith('http://') || href.startsWith('https://')) return 'external';
  return 'unknown';
}

function getElementType(element) {
  if (element.classList?.contains('analytics-click')) return 'card';
  if (element.tagName === 'A') return 'link';
  if (element.tagName === 'BUTTON') return 'button';
  if (element.getAttribute('role') === 'button') return 'button';
  return 'element';
}

function getClickTargetDescriptor(element) {
  if (element.id) return `#${element.id}`;
  if (element.className && typeof element.className === 'string') {
    const firstClass = element.className.split(' ').find(Boolean);
    if (firstClass) return `.${firstClass}`;
  }
  return element.tagName.toLowerCase();
}

function findClickableTarget(event) {
  const target = event.target;
  if (!(target instanceof Element)) return null;

  const explicit = target.closest(`[${ANALYTICS_ID_ATTR}], .analytics-click, a, button, [role="button"]`);
  if (!explicit) return null;

  if (explicit.closest('[data-analytics-ignore="true"]')) {
    return null;
  }

  return explicit;
}

function handleDocumentClick(event) {
  try {
    const element = findClickableTarget(event);
    if (!element) return;
    if (element.closest(`[${HANDLED_ATTR}="true"]`)) return;

    const href = element instanceof HTMLAnchorElement ? element.href : element.closest('a')?.href;
    const linkUrl = href || undefined;
    const session = getSessionState();

    trackEvent(EVENTS.ELEMENT_CLICK, {
      element_type: getElementType(element),
      element_id: element.getAttribute(ANALYTICS_ID_ATTR) || getClickTargetDescriptor(element),
      element_text: getVisibleText(element),
      link_url: linkUrl,
      link_type: getLinkType(linkUrl || ''),
      section_id: session.currentSection,
      click_target: getClickTargetDescriptor(element),
    });
  } catch (error) {
    // Analytics must never break the site.
  }
}

export function initClickTracker() {
  if (initialized) return () => {};
  initialized = true;

  document.addEventListener('click', handleDocumentClick, true);

  return () => {
    document.removeEventListener('click', handleDocumentClick, true);
    initialized = false;
  };
}

export function markAnalyticsHandled(element) {
  if (element?.setAttribute) {
    element.setAttribute(HANDLED_ATTR, 'true');
  }
}
